<template>
  <div class="manage-notice">

    <!-- START Search Box -->
    <div class="row">
      <div class="col">
        <div class="card shadow" >
          <div class="card-body">
            <div class="row">
              <div class="col-xl-3">
                <b-form-group label-class="col-form-label"
                              label="Search" label-for="noticeSearchBox"
                              label-cols="3" content-cols="9">
                  <b-input-group>
                    <b-form-input id="noticeSearchBox" type="search" placeholder="제목 or 내용" v-model="searchWord" @input="resetShowDetails" />
                  </b-input-group>
                </b-form-group>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- END Search Box -->

    <!-- START Notice List -->
    <div class="row">
      <div class="col">
        <div class="card shadow">
          <div class="card-body">
            <div style="min-height: 66vh;">

              <div class="row mb-2">
                <div class="col">
                  <div class="float-end me-2">
                    <total-count :count="pagination.totalCount" unit="건" />
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="table-responsive">
                  <b-table class="datatables text-nowrap" bordered hover
                           selectable
                           select-mode="single"
                           :fields="fields" :items="items"
                           :filter="searchWord"
                           :filter-included-fields="filterFields"
                           :filter-debounce="150"
                           :per-page="pagination.perPage"
                           :current-page="pagination.currentPage"
                           @filtered="onFiltered"
                           @row-clicked="rowClick">

                    <template #cell(index)="data">
                      {{ $_utils.rowNo(data.index, pagination.totalCount, pagination.perPage, pagination.currentPage) }}
                    </template>
                    <template #cell(title)="data">
                      <span>{{ data.item.title }}</span>
                      <i class="mdi mdi-paperclip icon-padding-left text-muted" v-if="!$_utils.isEmpty(data.item.attachFile)" />
                    </template>
                    <template #cell(created)="data">
                      {{ $_utils.changeDateFormat(data.item.created) }}
                    </template>

                    <template #row-details="data">
                      <div class="card row-detail mb-0">
                        <div class="card-body">
                          <viewer :initialValue="data.item.contents" />

                          <div v-if="!$_utils.isEmpty(data.item.attachFile)">
                            <div class="text-align-end">
                              <i class="mdi mdi-paperclip icon-padding-right text-muted" />
                              <span class="text-muted ct-padding-right-50">첨부 파일 :</span>
                              <a :href="`/onmapi/file/download/${data.item.attachFile.fileId}`" download>
                                {{ data.item.attachFile.orgName }}
                              </a>
                              <span class="text-muted ct-padding-left-25">({{ data.item.attachFile.fileSize > 1024 ? `${Math.round((data.item.attachFile.fileSize/1024)*10)/10}MB` : `${data.item.attachFile.fileSize}KB` }})</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="text-align-end mt-3">
                        <b-button variant="outline-deep-green" size="sm" class=" me-2"
                                  @click="onClickUpdate(data.item)"> 수정
                        </b-button>
                        <b-button variant="outline-deep-green" size="sm" @click="onClickDelete(data.item.id)"> 삭제
                        </b-button>
                      </div>
                    </template>

                  </b-table>
                </div>
              </div>

              <div class="row">
                <div class="mt-3">
                  <b-pagination class="mb-1 pagination-no-border" size="sm" align="center" v-model="pagination.currentPage"
                                first-number last-number prev-text="<" next-text=">"
                                :total-rows="pagination.totalCount"
                                :per-page="pagination.perPage"
                                @change="resetShowDetails" />
                </div>
              </div>

              <div class="row">
                <div class="manage-btns-container">
                  <b-button variant="outline-deep-green" @click="create"> 등록</b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- END Notice List -->

    <NoticeEditModal ref="noticeEditModal"
                     :mode="mode"
                     @change-notice-mode="mode=$event"/>

  </div>
</template>

<script>
import TotalCount from '@/views/components/totalCount.vue';
import '@toast-ui/editor/dist/toastui-editor-viewer.css';
import { Viewer } from '@toast-ui/vue-editor';
import NoticeEditModal from '@/views/pages/manage/NoticeEditModal.vue';
import CommonMixin from "@/assets/js/common-mixin";

export default {
  mixins: [ CommonMixin ],
  components: { TotalCount, viewer: Viewer, NoticeEditModal },
  data() {
    const _nApi = this.$_app.service.notice
    return {
      noticeApi: _nApi,
      searchWord: null,
      filterFields: [ 'title', 'contents' ],
      fields: [
        { key: 'index', label: 'No.', class: 'col-1 text-center' },
        { key: 'title', label: '제목' },
        { key: 'created', label: '등록일', class: 'col-2 text-center' }
      ],
      items: [],
      pagination: {
        currentPage: 1,
        totalCount : 0,
        perPage: 10,
      },
      mode: 'list',
    }
  },
  created() {
    const vm = this;
    vm.getItems();
  },
  watch: {
    mode(val) {
      const vm = this;

      if (val === 'list') vm.getItems();
    }
  },

  methods: {
    getItems() {
      const vm = this;

      vm.noticeApi.searchByJql({}, '-created', 2000, 1)
        .then(res => {
          vm.items = res.content;
          vm.pagination.totalCount = res.totalElements;
        }).catch(err => {
          console.log('Get Notice List Error :: ', err);
        });
    },
    onFiltered(filteredItems) {
      const vm = this;

      if (vm.pagination.totalCount !== filteredItems.length) {
        vm.pagination.currentPage = 1;
      }

      vm.pagination.totalCount = filteredItems.length;
    },
    resetShowDetails() {
      const vm = this;

      vm.items.forEach(item => {
        this.$set(item, '_showDetails', false);
      });
    },
    rowClick(row) {
      const vm = this;

      if (row._showDetails) {
        this.$set(row, '_showDetails', false);
      } else {
        vm.items.forEach(item => {
          this.$set(item, '_showDetails', false);
        });

        vm.$nextTick(() => {
          this.$set(row, '_showDetails', true);
        });
      }
    },

    onClickUpdate(content) {
      const vm = this;

      vm.mode = 'update';
      this.$nextTick(() => {
        vm.$refs.noticeEditModal.showModal(content);
      })
    },
    onClickDelete(id) {
      const vm = this;

      this.$swal({
        title: '삭제하시겠습니까?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: '확인',
        cancelButtonText: '취소',
      }).then(result => {
        if (result.isConfirmed) {

          vm.delete(id);
        }
      });
    },
    delete(id) {
      const vm = this;

      this.$axios.delete(`/onmapi/notice/delete/${id}`)
        .then(res => {
          console.log(res)
          vm.$swal('삭제 완료', '성공적으로 삭제되었습니다.', 'success')
            .then(result => {
              if (result.isConfirmed) vm.getItems();
            });
        })
    },
    create() {
      const vm = this;

      vm.mode = 'create';
      vm.$refs.noticeEditModal.showModal();
    },
  }
}

</script>